import { LitElement, html, css } from '~/lib/bn-lit-element';
import { sharedStyles } from '../styles/shared-styles';

class QrLayout extends LitElement {
  static get styles() {
    return [sharedStyles, css`
      :host {
        position: absolute;
        top: 0;
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
        background-color: #fff;
        overflow-y: auto;
      }
      .head {
        display: flex;
        justify-content: center;
        padding: 1rem;
        border-bottom: 1px solid var(--gray-40);
      }
      .content {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        margin: 1rem;
      }
      .actions {
        display: flex;
        justify-content: center;
        padding: 1rem;
        background-color: var(--gray-10);
        border-top: 1px solid var(--gray-40);
        position: sticky;
        bottom: 0;
      }
      .actions ::slotted(*) {
        display: flex;
        gap: 1rem;
      }
    `];
  }

  render() {
    return html`
      <div class="head">
        <a href="/">
          <img src="/images/binsentry_logo.svg" alt="BinSentry Logo" />
        </a>
      </div>
      <div class="content">
        <slot></slot>
      </div>
      <div class="actions">
        <slot name="actions"></slot>
      </div>
    `;
  }
}

customElements.define('qr-layout', QrLayout);
